import { ElementRef, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ScrollUtilityService {
  constructor() {}

  public scrollToElement(elementRef: ElementRef): void {
    elementRef?.nativeElement.scrollIntoView({
      behavior: 'smooth',
    });
  }
}
